const calculateHeadToHead = (
  teamAId,
  teamBId,
  group,
  schedule,
  matches,
  teamStats
) => {
  let returnValue = 0;
  let counter = 0;

  group.forEach((teamId) => {
    if (teamStats[teamId]?.points === teamStats[teamAId]?.points) {
      counter++;
    }
  });

  if (counter >= 3) return 0;

  Object.values(schedule).forEach((day) =>
    day.forEach((matchId) => {
      const match = matches[matchId];
      if (
        match &&
        [match.team1Id, match.team2Id].includes(teamAId) &&
        [match.team1Id, match.team2Id].includes(teamBId)
      ) {
        if (match.team1Id === teamAId) {
          returnValue = match.team2Score - match.team1Score;
        } else {
          returnValue = match.team1Score - match.team2Score;
        }
      }
    })
  );

  return returnValue;
};

export default calculateHeadToHead;
